export const locales = ['en', 'zh'] as const
export const defaultLocale = 'en' as const

export type Locale = (typeof locales)[number]

export const LANG_STORAGE_KEY = 'lang'
export const LEGACY_LANG_STORAGE_KEY = 'user-locale'
export const LANG_COOKIE_NAME = 'lang'

export const isLocale = (value: string | null | undefined): value is Locale =>
  value === 'en' || value === 'zh'

export const normalizeLocale = (value: string | null | undefined): Locale => {
  const normalized = value?.trim().toLowerCase()

  if (!normalized) return defaultLocale
  if (normalized === 'zh' || normalized.startsWith('zh-') || normalized.startsWith('zh_')) return 'zh'
  if (normalized === 'en' || normalized.startsWith('en-') || normalized.startsWith('en_')) return 'en'

  return defaultLocale
}
